import React from "react";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import { i18n } from "../../translate/i18n";

const StepConclusao = ({ state, resultadoTeste, onAbrirConfiguracoes, onFechar }) => (
  <div>
    <Typography variant="h6" gutterBottom>
      {i18n.t("whatsappOficialWizard.conclusao.titulo")}
    </Typography>

    {resultadoTeste === null && (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <CircularProgress size={18} />
        <Typography variant="body2">
          {i18n.t("whatsappOficialWizard.conclusao.testando")}
        </Typography>
      </div>
    )}

    {resultadoTeste && resultadoTeste.ok && (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <CheckCircleIcon style={{ color: "green" }} />
        <Typography variant="body2">
          {i18n.t("whatsappOficialWizard.conclusao.testeOk")}
        </Typography>
      </div>
    )}

    {resultadoTeste && !resultadoTeste.ok && (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <ErrorIcon color="error" />
        <Typography variant="body2">
          {i18n.t("whatsappOficialWizard.conclusao.testeFalhou")} {resultadoTeste.erro}
        </Typography>
      </div>
    )}

    <Typography variant="subtitle2" style={{ marginTop: 20 }}>
      {i18n.t("whatsappOficialWizard.conclusao.resumo")}
    </Typography>
    <Typography variant="body2" color="textSecondary">
      {state.nome} · {state.phoneNumberId} ·{" "}
      {state.webhookVerificado
        ? i18n.t("whatsappOficialWizard.webhook.verificado")
        : i18n.t("whatsappOficialWizard.webhook.naoVerificado")}
    </Typography>

    <div style={{ marginTop: 20, display: "flex", gap: 8 }}>
      <Button color="primary" variant="contained" onClick={onAbrirConfiguracoes}>
        {i18n.t("whatsappOficialWizard.conclusao.abrirConfiguracoes")}
      </Button>
      <Button onClick={onFechar}>
        {i18n.t("whatsappOficialWizard.conclusao.verConexoes")}
      </Button>
    </div>
  </div>
);

export default StepConclusao;
